import React from "react";
import "./about.scss";
import SectionHeader from "../../components/section_header/SectionHeader";
import logo from "../../assets/logo_no_consult.PNG";
import aboutMoreImg from "../../assets/about_more_sm.png";
const About = () => {
  return (
    <div className="about_main">
      <SectionHeader name={"ABOUT US"} />
      <div className="about_contents">
        <div className="card">
          <div className="card-header">
            <img src={logo} alt="highqc.com" />
            <h2>
              HIGH <span>Q</span>
              <br /> CONSULTING
            </h2>
          </div>

          <div className="card-body">
            <p className="card-text">
              We are a dedicated consulting firm passionate about supporting the
              food and allied industries in standardization, regulation, and
              conformance. With a strong foundation in industrial expertise and
              a commitment to continuous improvement, we help businesses
              navigate these complex challenges.
            </p>
          </div>
        </div>

        <div className="about_more">
          <img src={aboutMoreImg} alt="highqc more information " />
          <h1>Your Partner in Food Industry Excellence</h1>
        </div>
      </div>
    </div>
  );
};

export default About;
